import type { AccountUserLicenseTypeInput } from '@frameio/graphql-client/generated';
import { Box, Segment, SegmentedControl } from '@frameio/vapor';
import TEXT from './generated/TEXT/UserLicenseTypeSelect';

TEXT.DEFINE({
  /** Accessible label for the user license type select */
  accessibleLabel: 'User seats',
  /** Member label */
  member: 'Member',
  /** Guest label */
  guest: 'Guest',
});

const WIDTH = 164;

export type UserLicenseTypeSelectProps = {
  value: AccountUserLicenseTypeInput;
  onChange: (value: AccountUserLicenseTypeInput) => void;
};

export const UserLicenseTypeSelect = ({
  value,
  onChange,
}: UserLicenseTypeSelectProps) => {
  return (
    <Box width={`${WIDTH}px`}>
      <SegmentedControl
        accessibleLabel={TEXT.accessibleLabel}
        onChange={onChange}
        size="small"
        value={value}
        variant="secondary"
      >
        <Segment label={TEXT.member} value="MEMBER" />
        <Segment label={TEXT.guest} value="GUEST" />
      </SegmentedControl>
    </Box>
  );
};
